import {createContext} from 'react';

const Context = createContext({
  // groups,
  // cases,
  // setCases,
  // role
});

export default Context;